import { WbsFrontend } from '@interserve/igx-angular'

export const SimulationMappingData: WbsFrontend = {
    layout: {
        style: {
            direction: 'row', // row | column
        },
        leftWbs: {
            type: 'grid',
        },
        leftWbsRules: {
            childDataKey: 'nodeObjects',
            hideHeader: true,
            rowSelection: 'single',
            hideRowSelectors: true,
            canMoveTopNode: false,
            height: '300px',
            width: '100%',
            fields: [
                {
                    name: 'name',
                    label: '名前',
                    dataType: 'string',
                },
            ],
        },
        rightWbs: {
            type: 'grid',
        },
        rightWbsRules: {
            childDataKey: 'nodeObjects',
            hideHeader: true,
            rowSelection: 'single',
            hideRowSelectors: true,
            height: '300px',
            width: '100%',
            fields: [
                {
                    name: 'name',
                    label: '名前',
                    dataType: 'string',
                },
            ],
        },
        footer: {
            buttons: [
                {
                    key: 'cancel',
                    label: '元に戻す',
                    color: 'cancel',
                    disable: false,
                    action: 'revert',
                },
                {
                    key: 'register',
                    label: '登録する',
                    color: 'primary',
                    disable: false,
                    action: 'saveButton',
                },
            ],
        },
        actionRules: {
            regist: [
                {
                    items: {},
                },
            ],
            delete: [
                {
                    items: {},
                },
            ],
            leftArrow: [
                {
                    event: 'forward',
                    conditions: [
                        {
                            key: 'rightSelected.wbsType',
                            value: ['cassette'],
                        },
                    ],
                },
            ],
            rightArrow: [
                {
                    event: 'backward',
                    conditions: [
                        {
                            key: 'leftSelected.wbsType',
                            value: ['cassette'],
                        },
                    ],
                },
            ],
            saveButton: [
                {
                    event: 'showSaveDialog',
                    items: {
                        messageCd: 'confirmRun',
                    },
                },
            ],
        },
    }
}